// extracted by mini-css-extract-plugin
module.exports = {"form":"classes_form__YcU9U","container":"classes_container__12k0t","header":"classes_header__25yd3","buttons":"classes_buttons__2kcdC"};